import React from 'react';
import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const ErrorContainer = styled.div`
	background-color: #ffbebe;
	border: 1px solid #ff5b5b;
	border-radius: 8px;
	padding: 12px;
	width: 100%;
	max-width: 432px;
	animation: ${slideIn} 0.5s ease;
	p {
		font-size: 14px;
		font-weight: 700;
		color: #323232;
		margin: 0 0 10px 0;
		padding: 0;
	}
	ul {
		margin: 0;
		padding: 0;
		list-style-type: disc;
		margin-left: 12px;
		li {
			font-size: 14px;
			font-weight: 400;
			color: #323232;
			&:not(:last-child) {
				margin-bottom: 4px;
			}
		}
	}
`;

const LoginError = () => {
    return (
        <ErrorContainer>
            <p>Something went wrong — please check:</p>
            <ul>
                <li>Email is correct and account is active</li>
                <li>You're using the sign-up email (check inbox)</li>
                <li>Email and password are typed correctly</li>
            </ul>
        </ErrorContainer>
    );
};

export default LoginError;
